import AttachmentData = App.Data.AttachmentData
import AttachmentType = App.Enums.AttachmentType

export function filterDocuments(documents: AttachmentData[] = [], types: AttachmentType[]) {
  return documents.filter((doc) => doc.type && types.includes(doc.type))
}
